var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.734 12.667H4.087a.62.62 0 01-.62-.62V4.4a.4.4 0 10-.8 0v7.647a1.427 1.427 0 001.42 1.42h7.647a.4.4 0 000-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 5.76l-.453-1.387a.427.427 0 00-.2-.233.407.407 0 00-.307 0l-1.393.44a.399.399 0 00-.05.734.4.4 0 00.303.02l.454-.154-2 3.02-2-1.487a.42.42 0 00-.547.12l-2.233 3.214a.393.393 0 00.326.62.386.386 0 00.327-.174l2-2.886 2 1.486a.407.407 0 00.463.016.367.367 0 00.11-.116l2.3-3.466.154.473a.406.406 0 00.38.273c.041.01.085.01.126 0a.387.387 0 00.24-.513z"
  })));
}
export default SvgDashboard;